export default {
  SET_REV(state, payload) {
    state.rev = payload.rev
  },
  SET_CHALLENGE(state, payload) {
    state.challenge = payload.challenge
  },
}
